/** Where to send an authenticated user after auth entry points. */
export function postAuthPath(kind: "register" | "returning"): "/timetable" | "/teach" {
  return kind === "register" ? "/timetable" : "/teach";
}
